const configurations = {}

;(function loadConfigurationSettings () {
  const requireModule = require.context('.', false, /^.*\.conf\.json$/)
  requireModule.keys().forEach((fileName) => {
    const canonicalName = fileName.replace(/^(\.\/)|\.conf\.json$/g, '')
    configurations[canonicalName] = requireModule(fileName)
  })
})()

export default configurations
